<template src="@/templates/bookings/bookingDetail.html"></template>

<script>
import BookingDetailModel from "@/models/bookingDetailModel";
import { mapActions, mapGetters } from "vuex";
import BookingStatusPopUp from "@/components/bookings/BookingStatusPopUp";
import ServiceDeliveryFormModel from "@/models/serviceDeliveryFormModel";
import fileView from "@/components/file/FileView";
import moment from "moment";

export default {
  name: "BookingDetail",
  props: ["ref_num", "booking_view", "parentComp"],
  components: { BookingStatusPopUp, fileView },
  data() {
    return {
      showDetail: false,
      bookingNotAvailable: false,
      bookingDetailModel: new BookingDetailModel(),
      serviceDeliveryFormModel: new ServiceDeliveryFormModel(),
      bookingStatus: {
        show: false,
        message: "",
        confirmed: false,
        justConfirmed: false,
      },
      showInfo: false,
      jobSlipStatus: false,
      bookingState: false,
      model: {},
      found: false,
      viewFileViewUploadedComp: false,
      isThis: "bookingDetail",
      availability: "n",
      showAvailabilityStatus: false,
      hideContactField: false,
      serviceDate: '',
    };
  },
  computed: {
    ...mapGetters(["getReturnToComp", "getClockActivity"]),
    isCancelled() {
      if (this.bookingDetailModel.cancellation == "Yes") {
        return true;
      } else {
        return false;
      }
    },
    locationDetailsModified() {
      return this.bookingDetailModel.location_details.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );
    },
    jobTitle() {
      if (this.isCancelled) {
        return "Job " + this.bookingDetailModel.ref_num + " - Cancelled";
      } else if (this.bookingDetailModel.not_serviced) {
        if (parseInt(this.bookingDetailModel.not_serviced) > 0) {
          return "Job " + this.bookingDetailModel.ref_num + " - Not Serviced";
        } else if (
          this.bookingDetailModel.not_serviced == null ||
          parseInt(this.bookingDetailModel.not_serviced) == 0
        ) {
          if (this.bookingDetailModel.int_id) {
            return this.validateServiceDate();
          }
        } else
          return "Job " + this.bookingDetailModel.ref_num + " - Not Serviced";
      } else if (this.bookingDetailModel.int_id) {
        return this.validateServiceDate();
      } else {
        return "";
      }
    },
    showJobTitle() {
      if (
        this.parentComp == "bookingavailable_telephone" ||
        this.parentComp == "bookingavailable_onsite" ||
        this.parentComp == "bookingavailable_video"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.scroll();

    Event.$on("goBackFromBookings", () => {
      this.goBack();
    });

    Event.$on("refreshBookingDetail", () => {
      this.initialFunction();
    });

    Event.$on("acceptDeclineBookings", (status) => {
      if (status) {
        this.acceptBooking();
      } else {
        this.declineBooking();
      }
    });

    Event.$on("availUnavailabilityBookings", (status) => {
      if (status) {
        this.availability = "y"; // y means available and n means unavailable which is default.
      }

      this.updateBookingAvailability();
    });

    Event.$on("viewFileViewComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.viewSDForm(this.bookingDetailModel);
      }, 50);
    });

    Event.$on("hideFileViewComp", (isThis) => {
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          thisComponent.viewFileViewUploadedComp = false;
        }, 50);
      }
    });
  },
  created: function () {
    this.initialFunction();
  },
  beforeDestroy() {
    Event.$off("goBackFromBookings");
    Event.$off("refreshBookingDetail");
    Event.$off("acceptDeclineBookings");
    Event.$off("availUnavailabilityBookings");
    Event.$off("viewFileViewComp");
    Event.$off("hideFileViewComp");
  },
  methods: {
    ...mapActions([
      "updateScrollStatus",
      "availableBooking",
      "updateJobMatchingConditions",
      "updateBookingDetailRefNum",
      "updateIcon",
      "updateBackButton",
      "updateBookingsConfirmed",
      "updateAcceptDeclineHide",
      "updateReturnToComp",
      "updateJobRefNum",
      "updateJobSlipsStatus",
      "updateHideAll",
      "updateClockOnHide",
      "updateClockOnOffHide",
      "updateCameraStateHide",
      "clearIntervalVariable",
      "updateJobSessionId",
      "updateAvailUnavailableHide",
      "updateServiceDate",
      "updateServiceStartTime",
      "updateServiceEndTime",
      "updateInter_trans",
    ]),
    moment: function () {
      return moment();
    },
    scroll() {
      console.log(
        "Scrolled Offset= " +
          (Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight)
      );
      console.log("Total Height= " + document.documentElement.offsetHeight);
      let thisComp = this;

      let bottomOfWindow = thisComp.computeScroll();
      if (bottomOfWindow) {
        thisComp.updateScrollStatus(true);
      }


      window.onscroll = function () {
        let bottomOfWindow = thisComp.computeScroll();
        if (bottomOfWindow) {
          thisComp.updateScrollStatus(true);
        }
      };
    },

    computeScroll() {
      let thisComp = this;
      let maxScrollTopYOffSet =
        Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) + window.innerHeight;
      let maxScrollTopYOffSetLess5 = maxScrollTopYOffSet - 5;
      let maxScrollTopYOffSetPlus5 = maxScrollTopYOffSet + 5;

      let bottomOfWindow = thisComp.isBetween(
        document.documentElement.offsetHeight,
        maxScrollTopYOffSetLess5,
        maxScrollTopYOffSetPlus5
      );

      // console.log("SCROLL COMPUTE", [
      //   document.documentElement.offsetHeight,
      //   maxScrollTopYOffSetLess5,
      //   maxScrollTopYOffSetPlus5,
      //   bottomOfWindow
      // ]);

      return bottomOfWindow;
    },

    capitalizeFirstLetter(word) {
      if (word) {
        word = word.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    },
    isBetween(n, a, b) {
      // return (n - a) * (n - b) <= 0;
      return (n > a && n < b);
    },
    initialFunction() {
      this.$vs.loading();
      if (this.ref_num) {
        this.updateReturnToComp(this.parentComp);
        this.updateJobRefNum(this.ref_num);
        this.getBookingDetail();
        this.availableBooking(false);
      } else {
        this.availableBooking(true);
      }
    },
    validateServiceDate() {
      let currentDateTime = moment();
      let currentDate = currentDateTime.format("YYYY-MM-DD");
      if (this.bookingDetailModel.service_date >= currentDate) {
        return (
          "Job " +
          this.bookingDetailModel.ref_num +
          " Details for " +
          this.capitalizeFirstLetter(
            this.bookingDetailModel.interpreters_name
          ) +
          " " +
          this.capitalizeFirstLetter(
            this.bookingDetailModel.interpreters_surname
          )
        );
      }
      return "Job " + this.bookingDetailModel.ref_num + " Details";
    },
    fetchSDPDetails() {
      this.serviceDeliveryFormModel.ref_num = this.ref_num;

      this.serviceDeliveryFormModel
        .checkSDPDetails()
        .then((JARModelRes) => {
          let res = JARModelRes.response.data;
          let found = res.found;
          if (found) {
            console.log("job slips already uploaded for this job");
            this.foundMessage();
            this.updateJobSlipsStatus(true);
            this.updateIcon(["file-image"]);
            this.updateClockOnOffHide(false);
          } else {
            console.log("job slips not uploaded for this job");
            this.updateJobSlipsStatus(false);
            this.updateIcon(["camera"]);
            this.updateCameraStateHide(false);
            this.updateClockOnOffHide(false);
          }

          this.serviceDeliveryFormModel
            .viewSDDetails()
            .then((JARModelRes) => {
              let res = JARModelRes.response.data;
              let error = res.error;

              console.log(res);

              if (!error) {
                this.model = res.data;
              } else {
                let errorMessage = "Fetch error. " + error;
                this.fetchError(errorMessage);
              }

              this.clearIntervalVariable();

              let thisComp = this;
              let model = this.model;
              const checkClockStates = async () => {
                await thisComp.updateJobMatchingConditions([0, model]);
              };

              checkClockStates().then(() => {
                /** Only triggers after the checkClockStates function's execution finalised **/
                Event.$emit("getClockOnOffStatus");
              });
            })
            .catch((SDPError) => {
              let errorMessage = "Network error. " + SDPError;
              this.fetchError(errorMessage);
              console.error(SDPError);
            });
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.fetchError(errorMessage);
          console.error(PCError);
        });
    },
    foundMessage() {
      this.$vs.notify({
        title: "Found!",
        text: "Slip has been Received already",
        time: 2000,
        color: "warning",
        position: "top-center",
      });
    },
    fetchError(errorMessage) {
      this.$vs.notify({
        title: "Error!",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    isValidInterpreter() {
      if (
        this.bookingDetailModel.int_id == null ||
        this.bookingDetailModel.int_id == ""
      ) {
        return true;
      } else if (
        this.bookingDetailModel.int_id.trim().toLowerCase() ==
        localStorage.getItem("fmInterpreterId").trim().toLowerCase()
      ) {
        return true;
      }
      return false;
    },
    getBookingDetail() {
      this.updateBackButton(true);
      this.updateHideAll();

      if (this.parentComp == "SDPending") {
        this.updateClockOnHide(true);
      } else {
        this.updateClockOnHide(false);
      }

      this.bookingDetailModel
        .fetch({
          url:
            this.$interpretersApiUrl +
            this.bookingDetailModel.getRoute("fetch") +
            "/" +
            this.ref_num,
          headers: { Bearer: localStorage.getItem("jwt") },
        })
        .then(() => {
          this.$vs.loading.close();
          if (!this.isValidInterpreter()) {
            this.showDetail = false;
            this.bookingNotAvailable = true;
            return;
          }
          this.showDetail = true;
          
          if (this.bookingDetailModel.calds) {
            /** Does CALDS has a professional details? If so, hide contact field in the booking details **/
            this.bookingDetailModel.calds.forEach((cald) => {
              if (cald.professional) {
                this.hideContactField = true;
              }
            });

            for (const cald of this.bookingDetailModel.calds) {
              if (cald.professional) {
                this.hideContactField = true;
                break;
              }
            }
          }

          /**Update booking detail ref_num in store, AppFooter clock on/off uses the ref_num*/
          this.updateBookingDetailRefNum(this.ref_num);

          if (this.bookingDetailModel.service_date) {
            let d = new Date(this.bookingDetailModel.service_date);
            this.serviceDate = moment(d).format("Do MMM YYYY");
          }

          if (this.bookingDetailModel.job_session_id) {
            this.updateJobSessionId(this.bookingDetailModel.job_session_id);
          }

          if (this.bookingDetailModel.inter_trans) {
            this.updateInter_trans(this.bookingDetailModel.inter_trans);
          }

          if (this.bookingDetailModel.service_date) {
            this.updateServiceDate(this.bookingDetailModel.service_date);
          }

          if (this.bookingDetailModel.service_time_start) {
            this.updateServiceStartTime(
              this.bookingDetailModel.service_time_start
            );
          }

          if (this.bookingDetailModel.service_time_end) {
            this.updateServiceEndTime(this.bookingDetailModel.service_time_end);
          }

          if (
            this.isCancelled ||
            parseInt(this.bookingDetailModel.not_serviced) > 0
          ) {
            return;
          }

          if (this.bookingDetailModel.int_id) {
          // if (false) {
            this.showInfo = false;
            this.bookingStatus.confirmed = true;
            this.updateBookingsConfirmed(true);

            if (this.bookingState) {
              this.model = this.bookingDetailModel;
            }
            this.fetchSDPDetails();
          } else {

            this.showInfo = true;

            /** Hide accept/decline button if the booking type is video regardless of web access. Show I'm Available/I'm Unavailable button.*/
            // if (this.bookingDetailModel.inter_trans.toLowerCase() == "video") {
            //   // this.updateAvailUnavailableHide(false);
            //   return;
            // }

            console.log('ACCESS LEVEL', this.bookingDetailModel.access_level);

            if (this.bookingDetailModel.access_level == 'available') {

              this.updateIcon(["", "check", "times"]);
              this.updateAcceptDeclineHide(true);
              this.updateAvailUnavailableHide(false);

            } else if (this.bookingDetailModel.access_level == 'accept') {

              this.updateAcceptDeclineHide(false);
              this.updateAvailUnavailableHide(true);

            } else {

              this.updateAvailUnavailableHide(true);
              this.updateAcceptDeclineHide(true);
            }

            // if (parseInt(this.bookingDetailModel.web_access) == 1) {
            //   this.updateIcon(["", "check", "times"]);
            //   this.updateAcceptDeclineHide(false);
            // } else if (parseInt(this.bookingDetailModel.web_access) == 2) {
            //   this.updateAvailUnavailableHide(false);
            // } else {
            //   this.updateAcceptDeclineHide(true);
            // }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();

          console.error("error status code");
          console.log(error.response.response.status);
          if (error.response) {
            if (error.response.response.status == "401") {
              Event.$emit("tokenExpiredLogout");
              return;
            }
          }

          console.error(error);
          debugger;
          this.$vs.loading.close();
        });
    },
    bookingType(booking_type) {
      let value = "";
      switch (booking_type.toLowerCase()) {
        case "inter":
          value = "Onsite Interpreting";
          break;
        case "ph int":
          value = "Phone Interpreting";
          break;
        case "video":
          value = "Video Interpreting";
          break;
        case "trans":
          value = "Translation";
          break;
        default:
          break;
      }
      return value;
    },
    acceptBooking() {
      this.$vs.loading();
      let data = {
        availability: "n",
        refNo: this.ref_num,
        message:
          "accepted via: mobile app - " +
          "current page: " +
          this.$route.path +
          " - current user:" +
          localStorage.getItem("fmInterpreterId") +
          " - stafflogin: " +
          localStorage.getItem("staffLogin"),
      };

      this.bookingDetailModel
        .bookingAccept(data)
        .then((res) => {
          if (res) {
            if (res.response.data) {
              let result = res.response.data;
              if (result.error) {
                this.bookingStatus.show = true;
                this.bookingStatus.confirmed = false;
                this.bookingStatus.message = result.message;
                this.$vs.loading.close();
              } else {
                this.showInfo = false;
                this.bookingStatus.show = true;
                this.bookingStatus.confirmed = true;
                this.bookingStatus.justConfirmed = true;
                this.bookingStatus.message =
                  "Please record your Job Number and other details accurately. To verify your booking please check your current confirmed bookings.";
                this.$vs.loading.close();
              }
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          this.$vs.notify({
            title: "Error",
            text: "Unable to accept booking!",
            color: "danger",
            icon: "error",
            position: "top-right",
          });
          debugger;
        });
    },
    declineBooking() {
      this.$vs.loading();
      let data = {
        availability: "n",
        refNo: this.ref_num,
      };

      this.bookingDetailModel
        .bookingDecline(data)
        .then((res) => {
          this.$vs.loading.close();
          if (res) {
            if (res.response.data) {
              let result = res.response.data;
              if (result.error) {
                this.bookingStatus.show = true;
                this.bookingStatus.confirmed = false;
                this.bookingStatus.message = result.message;
              } else {
                this.updateBackButton(false);
                this.updateHideAll();
                this.$router.push({ path: "/bookingdecline" });
              }
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          this.$vs.notify({
            title: "Error",
            text: "Unable to decline booking!",
            color: "danger",
            icon: "error",
            position: "top-right",
          });
          debugger;
        });
    },
    updateBookingAvailability() {
      this.$vs.loading();
      let data = {
        availability: this.availability,
        refNo: this.ref_num,
      };

      this.bookingDetailModel
        .bookingAvailUnavailable(data)
        .then((res) => {
          this.$vs.loading.close();
          if (res) {
            if (res.response.data) {
              let result = res.response.data;
              if (result.error) {
                this.bookingStatus.show = true;
                this.bookingStatus.confirmed = false;
                this.bookingStatus.message = result.message;
              } else {
                this.updateBackButton(false);
                this.updateHideAll();
                this.showAvailabilityStatus = true;
                this.bookingStatus.message = result.message;
              }
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          this.$vs.notify({
            title: "Error",
            text: "Unable to decline booking!",
            color: "danger",
            icon: "error",
            position: "top-right",
          });
          debugger;
        });
    },
    closeBooking(status) {
      this.bookingStatus.show = status;
      let thisEvent = this;
      setTimeout(function () {
        thisEvent.gotoBookingAvailable();
      }, 50);
    },
    gotoBookingAvailable() {
      // this.$router.go(-1);
      this.$router.push({ path: "/" + this.parentComp });
    },
    goBack() {
      this.updateBackButton(false);
      this.updateScrollStatus(false);
      this.$router.push({ name: this.getReturnToComp });
      // this.updateCameraState(false);
      // Event.$emit('hideSDPendingDetailsComp');
    },
    viewSDForm(model) {
      console.log(model);
      this.viewFileViewUploadedComp = true;
      // Testing for the git
    },
    checkCancellation() {
      if (this.bookingDetailModel.cancellation == "Yes") {
        return "colorRed ";
      } else {
        return "";
      }
    },
    closeDialogBox() {
      this.showAvailabilityStatus = false;
      let thisEvent = this;
      setTimeout(function () {
        thisEvent.gotoBookingAvailable();
      }, 50);
    },
  },
};
</script>

<style scoped>
.noticeBookingDetail {
  margin: 5px 0 15px 0;
}

#ulBookingDetail li {
  padding: 10px;
  list-style: none;
}

#ulBookingDetail li:nth-child(even) {
  background: #ffffff;
}

#ulBookingDetail li:nth-child(odd) {
  background: #eeeeee;
}

#bookingDetailFooter {
  margin-bottom: 100px;
  margin-top: 20px;
}
</style>
